<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>

      <el-form-item label="分类"  >
        <el-button size="small" type="primary" @click="addCategory" >新增分类</el-button>
        <el-table :data="form.category" border size="mini" style="width: 100%;margin-top: 20px;">
          <el-table-column prop="id" label="编号" width="200">
              <template v-slot="scope">
                <div class="d-s-c">
                  {{ scope.row.id }}
                </div>
              </template>

            </el-table-column>
          
          <el-table-column prop="name" label="分类名称" width="250">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 200px;" v-model="scope.row.name"  placeholder="请输入分类名称"></el-input>
                </div>
              </template>

            </el-table-column>


            <el-table-column prop="sort" label="排序" width="250">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input style="width: 200px;" v-model="scope.row.sort"  placeholder="请输入排序"></el-input>
                </div>
              </template>

            </el-table-column>
                 
  

            <el-table-column prop="name" label="操作"  width="100">
              <template v-slot="scope">
                <div style="color: blue;" @click="delCategory(scope.$index)">删除</div>

              </template>
            </el-table-column>
          </el-table>
      </el-form-item>

      <el-form-item size="small" label="推荐产品" >
        <div>优先根据商品标签去推荐商品，如档案提到体虚，则会推荐对应标签【体虚】的商品；选择【产品】【产品标签】</div>
        <div>推荐商品则会直接出现在档案最下方</div>
        
        <div class="common-level-rail"><el-button size="small" icon="el-icon-plus" @click="addClick">添加商品</el-button></div>
        <div class="pb50">
          <el-table size="small" :data="tableData" border>
            <el-table-column label="图片" width="60">
              <template slot-scope="scope">
                <div class="product-info">
                  <div class="pic"><img width="30px" height="30px" v-img-url="scope.row.product_image" /></div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="product_name" label="商品"></el-table-column>
            <!-- <el-table-column label="排序" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.sort" type="number" :disabled="form.is_recommend == 0 ? true : false"></el-input>
              </template>
            </el-table-column> -->
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="deleteClick(scope.row)" type="text" size="small" :disabled="form.is_recommend == 0 ? true : false">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>


    </el-form>

    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>

    <!--商品图片组件-->
    <!-- <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload> -->
 
  <!--选择商品-->
  <Product :isproduct="isproduct" :islist="islist" @closeDialog="closeProductDialogFunc($event)">产品列表弹出层</Product>
 </div>
</template>
<script>
import HrecordsApi from '@/api/hrecords.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
import Product from '@/components/product/Product';
export default {
  components: {
    Upload,
    draggable,
    Product
  },
  data() {
    return {
      form: {
        status: false,
        category:[],
        product_arr:[],
        product_arr_ids:[],
      },
      setting: [],
      loading: false,
      isProductUpload:false,
      isproduct:false,
      tableData:[],
      islist:false,
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
   /*关闭弹窗*/
   closeProductDialogFunc(e) {
    console.log(' e.params', e.params)
    e.params = e.params;
      this.isproduct = e.openDialog;
      if (e.type == 'success') {
        if (this.form.product_arr_ids.indexOf(e.params.product_id) > -1) {
          this.$message({
            message: '你已选中该产品',
            type: 'error'
          });
          return false;
        }
        let param = {};
        param.product_id = e.params.product_id;
        param.product_name = e.params.product_name;
        param.product_image = e.params.image;
        param.sort = 1;
        this.tableData.push(param);
        this.form.product_arr = this.tableData;
        this.form.product_arr_ids.push(e.params.product_id);
      }
    },
    /*添加商品*/
    addClick() {
      this.isproduct = true;
    },
    /*删除商品*/
    deleteClick(e) {
      let index =  this.form.product_arr_ids.indexOf(e.product_id);
      this.form.product_arr.splice(index, 1);
      this.form.product_arr_ids.splice(index, 1);
      this.tableData.splice(index, 1);
    },

    addCategory(){
      this.form.category.push({
        "id": this.form.category.length>=1?  this.form.category[this.form.category.length-1].id+1 :1,
        "name":"",
        "val":0,
        "sort":1,
        
      });
    },
    delCategory(idex){
      this.form.category.splice(idex,1)
    },

    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      HrecordsApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.form = data.data.vars.values;
          }
          if(!this.form.category){
            this.form.category = [];
          }
          if(!this.form.product_arr){
            this.form.product_arr = [];
          }else{
            this.tableData =  this.form.product_arr;
          }

          if(!this.form.product_arr_ids){
            this.form.product_arr_ids = [];
          }
          
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      HrecordsApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/hrecords/setting/getSetting.vue